import { useEffect, useMemo, useState } from "react";

import {
  ColumnSortEnum,
  TableMetadata,
    useTable,
    Button
} from "@king-ict/eupisi-ui/components";
import { ReactComponent as Download } from "@king-ict/eupisi-ui/components/Icon/Download.svg";
import { PagedResult } from "@king-ict/eupisi-ui/models";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import {
    exportBeneficiaryList as exportBeneficiaryListApi,
  searchBeneficiary,
} from "../../api";
import {
  AdministrationListHeader,
  AdministrationList,
} from "../../components";
import {
  Beneficiary,
  BeneficiaryFilter
} from "../../models";
import { BeneficiaryListSearchFilters } from "../Beneficiary";
import BeneficiarySortEnum from "./BeneficiarySortEnum";

export const BeneficiaryList = () => {
  

const [tableData, setTableData] = useState<
PagedResult<Beneficiary>
>(({
rowCount: 0,
results: [],
} as unknown) as PagedResult<Beneficiary>);

const setUniquValue = tableData?.results?.map((element, i) => {
  element.uniqueValue = (i.toString());
});

  const { t } = useTranslation();

  const [filters, setFilters] = useState<BeneficiaryFilter>({
  } as BeneficiaryFilter);

  const handleSearch = () => {
    setTableFilters({
      ...filters,
    });
  };

  const tableMetadata = useMemo(
    () =>
      ({
        rowKey: "uniqueValue",
        columns: [
        {
          columnKey: "firstName",
          header: t("beneficiary.firstName"),
          accessor: "firstName",
          sortBy: BeneficiarySortEnum.FirstName,
        },
        {
          columnKey: "lastName",
          header: t("beneficiary.lastName"),
          accessor: "lastName",
          sortBy: BeneficiarySortEnum.LastName,
        },        
        {
          columnKey: "roleName",
          header: t("common.role"),
          accessor: "roleName",
          sortBy: BeneficiarySortEnum.RoleName,
        },
        {
          columnKey: "institutionName",
          header: t("common.kindergaten"),
          accessor: (Beneficiary) => {
            return `${Beneficiary.institutionName}, ${Beneficiary.townName}`;
          },
          sortBy: BeneficiarySortEnum.InstitutionName,
        },
        {
          columnKey: "institutionOIB",
          header: t("beneficiary.kindergatenOIB"),
          accessor: "institutionOIB",
          sortBy: BeneficiarySortEnum.InstitutionOIB,
        },
      ],
    } as TableMetadata<Beneficiary>),
    [t]
  );

  const [
    tableProps, tableState, setTableFilters, ] = useTable<BeneficiaryFilter>({
    metadata: tableMetadata,
    data: tableData.results,
    totalItems: tableData.rowCount,
    pagination: true,
    defaultSort: {
      sortBy: BeneficiarySortEnum.LastName,
      order: ColumnSortEnum.ASC,
    },  });

  useEffect(() => {
    (async () => {
      setTableData(await searchBeneficiary(tableState));
    })();
  }, [tableState]);

    const handleDownloadExcel = () => {
        if (!tableData) {
            return;
        }

        exportBeneficiaryListApi({
            ...filters
        });
    };


  return (
    <>
      <AdministrationListHeader
        infoMessage={
          t("beneficiary.listInfoMessageDV")
        }
        title={t("sidebar.beneficiaryList")}
      />
      <BeneficiaryListSearchFilters
        handleSearch={handleSearch}
        filters={filters}
        setFilters={setFilters}
      />
      <AdministrationList
        tableProps={tableProps}        
        isDetailsEnabled={false}
      />

          <Col
              md={12}
              className={"p-0 text-right mt-2 mb-4"}
          >
              <Button
                  size="sm"
                  color="primary"                  
                  disabled={!tableData || tableData.results.length === 0} 
                  outline
                  icon={<Download />}
                  onClick={handleDownloadExcel}
              >
                  {t("request.initialConversation.download")}
              </Button>
          </Col>

    </>
  )
};
